import { NamedEntityPropertyType } from '../../../../common-modules/interfaces/NamedEntityPropertyType';

export enum QuestionTypeEnum {
    EnterprisePremium = 0,
    Foundations_msp = 1,
    Foundation_smb = 2,
}

export const QuestionTypeMapping: { [type in QuestionTypeEnum]: { name: string; checked: boolean } } = {
    [QuestionTypeEnum.EnterprisePremium]: {
        name: $localize`Enterprise / Premium`,
        checked: true,
    },
    [QuestionTypeEnum.Foundations_msp]: {
        name: $localize`Foundations (MSP)`,
        checked: false,
    },
    [QuestionTypeEnum.Foundation_smb]: {
        name: $localize`Foundations (SMB)`,
        checked: false,
    },
};

export class QuestionType implements NamedEntityPropertyType {
    public getName(type: QuestionTypeEnum): string {
        return QuestionTypeMapping[type].name;
    }

    public getStatus(type: QuestionTypeEnum): boolean {
        return QuestionTypeMapping[type].checked;
    }

    public getAllTypes(): QuestionTypeEnum[] {
        return Object.keys(QuestionTypeMapping) as any as QuestionTypeEnum[];
    }
}
